import { forwardRef } from "react";
import { Search, X } from "lucide-react";

/**
 * SearchInput — the search-bar field used on Home and Search pages.
 * Deliberately not built on top of <TextInput> — it needs a distinct,
 * pill-shaped visual treatment (see FilterButton usage pattern) rather
 * than the standard rectangular form-field look.
 */
const SearchInput = forwardRef(function SearchInput(
  { value, onChange, onClear, placeholder = "Hudud yoki kalit so'z qidiring...", className = "", ...rest },
  ref
) {
  return (
    <div
      className={[
        "flex items-center gap-2.5 rounded-pill bg-white border border-brand-line px-4 h-12",
        "focus-within:border-brand-primary transition-colors duration-150",
        className,
      ].join(" ")}
    >
      <Search size={18} className="text-brand-muted flex-shrink-0" />
      <input
        ref={ref}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="flex-1 min-w-0 bg-transparent outline-none text-body-md text-brand-ink placeholder:text-brand-muted"
        {...rest}
      />
      {value && onClear && (
        <button
          type="button"
          onClick={onClear}
          aria-label="Tozalash"
          className="flex-shrink-0 text-brand-muted hover:text-brand-ink"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
});

export default SearchInput;
